import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "context/LanguageContext";
import { fetchSubcategoriesAsync } from "store/slices/subcategoriesSlice";
import FeaturedCategories from "features/categories/components/FeaturedCategories";
import BackButton from "shared/components/BackButton";
import Loading from "shared/components/Loading";
import { MdHome } from "react-icons/md";

export default function SubcategoriesPage() {
  const { language } = useTranslation();
  const isRTL = language === "ar";
  const { categoryId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate("/");
  }

  const categoryName = location.state?.categoryName || "Categories";
  
  const dispatch = useDispatch();
  const { items: subcategories, loading, error, currentCategoryId } = useSelector(
    (state) => state.subcategories
  );

  useEffect(() => {
    if (categoryId && categoryId !== currentCategoryId) {
      dispatch(fetchSubcategoriesAsync(categoryId));
    }
  }, [dispatch, categoryId, currentCategoryId]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center"
        dir={isRTL ? "rtl" : "ltr"}
      >
        <div className="text-center">
          <p className="text-red-600">Error: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="bg-white shadow-sm sticky top-0 z-10">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={handleHomeClick}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              aria-label="Go to home"
            >
              <MdHome className="w-6 h-6 text-blue-600" />
            </button>
            <BackButton title={categoryName} />
            
          </div>
        </div>
      </div>

      <div className="min-h-screen bg-gray-50" dir={isRTL ? "rtl" : "ltr"}>
        <div className="container mx-auto px-4 pt-0 pb-6">
          <FeaturedCategories featuredSubcategories={subcategories} />
        </div>
      </div>
    </>
  );
}
